import AWS from 'aws-sdk';
import axios from 'axios';
import { formatDisplayDateTime } from '../../lib/dateDisplay';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppConfig, JWT } from '../../config';
import { Translate as t } from '../../config/Translate';
import getOSSClient from '../../lib/oss';
import { RayDelButton, S3DownloadButton } from './Buttons';

AWS.config.update({ accessKeyId: AppConfig.S3_ID, secretAccessKey: AppConfig.S3_KEY, region: AppConfig.S3_REGION });
// const s3 = new AWS.S3({ params: { Bucket: AppConfig.S3_BUCKET }, region: AppConfig.S3_REGION });

// R2 upload functions
const getUploadUrl = async (filepath) => {
	const ret = await axios.get(`https://common.rayplatform.com/file/get-upload-url?filepath=${filepath}&bucket=rayteams-common`);
	return ret?.data?.signedUrl || '';
};

// BUG-228 (#447): 공용 업로드 경로 파일 크기 상한(사용자 확정 2026-09-03).
// 개별 화면이 더 엄격한 상한을 따로 두는 것은 그대로 유지된다(useImageUpload 5MB 등).
const MAX_UPLOAD_BYTES = 100 * 1024 * 1024;

// BUG-228 (#447): 파일 본문 PUT 은 전역 axios timeout(30초, src/lib/axiosSetup.js)을 상속하면
// 안 된다. 업로드 소요시간은 파일 크기·회선속도에 비례하므로, 저속 회선에서 수십 MB 파일이
// `timeout of 30000ms exceeded` 로 실패했다(딜러 엔지니어 첨부 실패).
// axios timeout 은 유휴 시간이 아니라 요청 전체 시간이라 `상한 크기 ÷ 타임아웃`이 곧 보장
// 최저 회선속도가 된다 — 100MB / 30분 ≈ 0.45Mbps 까지 완주 가능. signed URL 발급 GET 은
// 소용량이라 전역값(30초)을 그대로 쓴다. 장시간 전송이 프리즈로 보이지 않게 진행률을 노출한다.
// F-003 (PR #566 R1): 이 값과 산식은 **R2 분기 한정**이다. 중국(RAY00100) Ali OSS 분기는
// ossClient.put 이라 axios timeout·진행률이 적용되지 않고 src/lib/oss.js 의 120초가 지배한다
// (해당 테넌트의 대용량 업로드 한계는 BUG-228 범위 밖 — 별도 조정 필요).
const UPLOAD_TIMEOUT_MS = 30 * 60 * 1000;

const uploadFile = async (url, file, onProgress) => {
	const { type: mimetype } = file;
	const options = {
		headers: {
			'Content-Type': mimetype,
		},
		timeout: UPLOAD_TIMEOUT_MS,
		onUploadProgress: (e) => {
			if (!onProgress || !e?.total) return;
			onProgress(Math.round((e.loaded / e.total) * 100));
		}
	};
	await axios.put(url, file, options);
};

export const FileUpload = ({ option = {}, extraData = {}, callback, basepath = "", uploadLater, doUpStart, callbackUpListChanged, button = null }) => {
	//const [t] = useTranslation();
	const [filevalue, setFilevalue] = useState("")
	const [progress, setProgress] = useState()
	const [uploadDone, setUploadDone] = useState()
	const [err, setErr] = useState("")
	const [upList, setUpLoad] = useState([])

	const uploadStart = async (file) => {
		const path = extraData?.path;
		const errors = [];
		setErr("");
		for (let i = 0; i < file.length; i++) {
			const currentFile = file[i];
			if (!currentFile) continue;
			try {
				// BUG-228: 대용량 업로드가 멈춘 것으로 보이지 않게 진행률을 표시한다.
				const res = await S3Upload(path, currentFile, { onProgress: setProgress });
				if (!option.doneandnew)
					setUploadDone(res);
				setFilevalue("");
				callback && callback(res);
			} catch (err) {
				console.error('File upload failed:', err);
				errors.push((currentFile.name || 'Unknown file') + ': ' + (err.message || 'Upload failed'));
			} finally {
				setProgress();
			}
		}
		if (errors.length > 0) {
			setErr(errors.join(', '));
		}
	}

	const delItem = () => {
		setUploadDone();
		callback && callback();
	}

	const hiddenFileInput = React.useRef(null);

	const handleChange = e => {
		uploadStart(e.target.files)
	};

	const handleClick = e => {
		hiddenFileInput.current.click();
	};

	useEffect(() => {
		if (doUpStart && upList.length > 0) {
			uploadStart(upList)
		}
	}, [doUpStart])

	useEffect(() => {
		callbackUpListChanged && callbackUpListChanged(upList)
	}, [upList])

	return (
		<>
			{uploadDone && <FileItem fileInfo={uploadDone} callback={() => delItem()} />
			}
			{!uploadDone &&
				<>
					<a onClick={(e) => handleClick(e)}>
						{!button ? <button className="btn btn-primary btn-block mt-0">{option.label || t('common.button.selectAFile')}</button> : button}
					</a>

					<input type="file"
						name={option.name || "file"}
						value={filevalue}
						ref={hiddenFileInput}
						style={{ display: 'none' }}
						onChange={e => uploadLater ? setUpLoad([...upList, ...e.target.files]) : uploadStart(e.target.files)}
						multiple
					/>
					{/* F-001 (PR #566 R1): progress 0 은 falsy 라 `progress &&` 로 걸면 0% 구간에서
						막대가 사라지고 숫자 0 만 텍스트로 출력된다(저속 회선 초기 수십 초). */}
					{Number.isFinite(progress) && <div>
						{/* BUG-228: progress-bar 클래스가 없어 진행 막대가 렌더되지 않았다(부트스트랩 5). */}
						<div className="progress">
							<div className="progress-bar progress-bar-success" style={{ width: `${progress}%` }}>{progress}%</div>
						</div>
					</div>}
				</>
			}
			{/* F-002 (PR #566 R1): 업로드 완료 항목이 표시되는 동안에도 차단·실패 사유가 보여야
				한다. `!uploadDone` 블록 안에 두면 doneandnew:false 경로에서 안내가 사라진다. */}
			{err && <div className="alert alert-danger">{err}</div>}
		</>
	)
}

export const FileItem = ({ fileInfo = {}, callback, showDel = true }) => {
	const [url, setUrl] = useState("");
	const [isAdmin, setIsAdmin] = useState(location.pathname.toLowerCase().startsWith('/admin/'));

	useEffect(() => {
		if (fileInfo.s3path && fileInfo.original) {
			const ext = ["JPG", "PNG", "JPEG"];
			if (ext.includes(fileInfo.s3path.slice((fileInfo.s3path.lastIndexOf(".") - 1 >>> 0) + 2).toUpperCase())) {
				getUrl();
			}
		}

	}, [fileInfo])

	const delFile = async () => {
		try {
			await axios.post(AppConfig.API_SERVER_PATH + "/file/delete", { path: fileInfo.s3path }, JWT());
			callback && callback(fileInfo);
		} catch (error) {
			console.warn('[FileUpload.FileItem.delFile] failed', {
				handler: 'FileUpload.FileItem.delFile',
				target: fileInfo?.s3path,
				reason: error?.message || String(error),
			});
		}
	}

	const getUrl = async () => {
		// Use directLink if available (R2 file)
		if(fileInfo.directLink){
			setUrl(fileInfo.directLink);
			return;
		}
		if(fileInfo.path?.startsWith('http')){
			setUrl(fileInfo.path);
			return;
		}
		try {
			const ret = await axios.post(AppConfig.API_SERVER_PATH + "/file/geturl", {
				path: fileInfo.s3path,
				ctype: "image/" + fileInfo.s3path.slice((fileInfo.s3path.lastIndexOf(".") - 1 >>> 0) + 2)
			}, JWT());

			if (ret.data.status == "success") {
				setUrl(ret.data.data);
			}
		} catch (error) {
			console.warn('[FileUpload.FileItem.getUrl] failed', {
				handler: 'FileUpload.FileItem.getUrl',
				target: fileInfo?.s3path,
				reason: error?.message || String(error),
			});
		}
	}

	return (
		<>
			{(fileInfo && !url) &&
				<>
					<div>
						{(fileInfo.path?.startsWith('http') || fileInfo.directLink) ? <div>
							<a href={fileInfo.directLink || fileInfo.path} target='_blank'>{fileInfo.name || fileInfo.original}</a>
							</div> : <S3DownloadButton
							text={fileInfo.name || fileInfo.original}
							path={fileInfo.s3path}
							filename={fileInfo.original}
							directLink={fileInfo.directLink}
							css="text-black" />
						}
						<div className='text small'>
							<Link to={(isAdmin ? "/Admin/AdminUserInfo/" : "/UserInfo/") + fileInfo.creator}>{fileInfo.creatorName}</Link> / {formatDisplayDateTime(fileInfo.createDate)}
						</div>
					</div>

					{showDel && <div className="rayrighttop"><RayDelButton callback={() => delFile()} css="btn btn-sm btn-danger float-end mt-0" /></div>}
				</>
			}
			{(fileInfo && url) &&
				<>
					{isAdmin && <div>
						<a href={url} target='_blank'><img src={url} style={{ maxWidth: 180, width: "100%" }} className='img-fluid fl pe-1' crossOrigin='anonymous' alt={fileInfo.name} /></a>
						<div className='text small'>
							<div>{fileInfo.name}</div>
							<Link to={(isAdmin ? "/Admin/AdminUserInfo/" : "/UserInfo/") + fileInfo.creator}>{fileInfo.creatorName}</Link> / {formatDisplayDateTime(fileInfo.createDate)}
						</div>
					</div>}
					{!isAdmin && <img src={url} style={{ width: "100%" }} className='img-fluid' crossOrigin='anonymous' alt={fileInfo.name} />}
					{showDel && <div className="rayrighttop"><RayDelButton callback={() => delFile()} css="btn btn-sm btn-danger float-end mt-0" /></div>}
				</>
			}
		</>
	)
}

const ossUserCompanyId = [
	"RAY00100"
]

export const S3Upload = async (path, file, option = {}) => {
	const original = !option.isBuffer ? file.name.replace(/^.*[\\\/]/, '') : option.filename;
	const randomSuffix = Math.random().toString(36).substring(2, 8);
	const filename = !option?.keepFileName ? new Date().getTime().toString() + "_" + randomSuffix + "." + (file.name?.split('.').pop() || option.filename?.split('.').pop()) : original;

	const user = JSON.parse(localStorage.getItem('user'));

	// BUG-228 (#447): 상한 초과 파일은 전송을 시작하지 않고 즉시 사용자에게 알린다(무음 금지).
	// 전송 도중 타임아웃으로 실패하는 것보다 선제 안내가 낫고, 무한 대기 위험도 함께 막는다.
	const fileSize = file?.size ?? 0;
	if (fileSize > MAX_UPLOAD_BYTES) {
		// F-004 (PR #566 R1): §7 warn 페이로드에 caller identity 포함.
		console.warn('[upload] 파일 크기 상한 초과 — 전송 생략', {
			handler: 'FileUpload.S3Upload',
			callerCompanyId: user?.companyId ?? '(없음)',
			callerAdminid: user?.adminid ?? '(없음)',
			path,
			original,
			size: fileSize,
			limit: MAX_UPLOAD_BYTES,
			reason: 'file exceeds MAX_UPLOAD_BYTES',
		});
		const tooLarge = new Error(t('io.message.error.fileTooLargeMax100Mb'));
		tooLarge.code = 'FILE_TOO_LARGE';
		throw tooLarge;
	}

	if(ossUserCompanyId.includes(user?.companyId)){
		try {
			const ossClient = await getOSSClient();
			const ret = await ossClient.put(path + filename, file);
			return { s3path: path + filename, filename, original, err: "", url : ret.url };
		} catch (err) {
			console.error('Ali OSS upload error:', err);
			throw err;
		}
	}else{
		// R2 upload using signed URL
		const filepath = 'rayguard/' + path + filename;
		try {
			const uploadUrl = await getUploadUrl(filepath);
			if (!uploadUrl) {
				throw new Error('Failed to get upload URL');
			}
			await uploadFile(uploadUrl, file, option?.onProgress);
			// Generate direct link URL for R2 file
			const directLink = `https://common.rayplatform.com/file/getfile?filepath=${encodeURIComponent(filepath)}`;
			return { s3path: filepath, filename, original, err: "", directLink };
		} catch (err) {
			console.error('Upload error:', err);
			throw err;
		}
	}
}
